<svg width="42" height="42" viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.89 12L23.85 12.4L20.11 30L18.15 29.6L21.89 12ZM28.59 21L25 17.41V14.58L31.42 21L25 27.41V24.58L28.59 21ZM10.58 21L17 14.58V17.41L13.41 21L17 24.58V27.41L10.58 21Z"/>
</svg>
